{
  "name": "@ns/select-subscription-card",
  "version": "1.1.0",
  "requiredPermission": "BILLING_MANAGE",
  "description": "Select a nodeStream subscription card",
  "inputs": {
    "subscriptionId": {
      "type": "string"
    }
  },
  "outcomes": {
    "complete": {}
  }
}
